import styled from "styled-components";
import PencilIcon from "../../../../../../generic/icons/IconLib/PencilIcon";


const Wrapper = styled.div`
    cursor: pointer;
    width: 2.5em;
    display: flex;
    justify-content: center;
    align-items: center;
 
`


export default function RemarkButton({handleOpenRemarkModal}){

    
    return(
        <Wrapper  onClick={handleOpenRemarkModal}>
            <PencilIcon />
        </Wrapper>
    );
}